import { View } from 'react-native'
// TODO: Re-enable once all translations are validated
// import { LanguageSwitcher } from './LanguageSwitcher'
import { landingHeaderControlsStyles as styles } from './LandingHeaderControls.styles'

export function LandingHeaderControls() {
  return (
    <View style={styles.row}>
      {/* TODO: Re-enable once all translations are validated */}
      {/* <LanguageSwitcher /> */}
    </View>
  )
}
